import React, { useRef, useEffect } from "react";
import "../css/twowheelerinsurance.css";
import twowheelerinsuranceimg from "../assets/twowheelerinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const TwoWheelerInsurance = () => {
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  const imageRefs = useRef([]);
  const imageSources = [
    twowheelerinsuranceimg, 
    tollfreenumberimg 
  ];

  useEffect(() => {
    if (imageRefs.current.length > 0) {
      let index = 0;

      const showNextImage = () => {
        imageRefs.current.forEach((img, i) => {
          if (img) img.style.display = i === index ? "block" : "none";
        });

        index++;
        if (index >= imageRefs.current.length) index = 0;
        setTimeout(showNextImage, 3000); 
      };

      showNextImage();
    }
  }, []);

  const handleSubmit = async (data) => {
    const inquriyData = new FormData();
    inquriyData.append("Name", data.Name);
    inquriyData.append("Email", data.Email);
    inquriyData.append("PreferredDate", data.Date);
    inquriyData.append("PreferredTime", data.Time);
    inquriyData.append("MobileNo", data.MobileNo);
    inquriyData.append("Status", "New");
    inquriyData.append("UserId", data.Id);
    inquriyData.append("InquiryType", "Insurance Inquiries");
    inquriyData.append("PolicyType", "Two Wheeler Insurance");
    inquriyData.append("IsLoggedIn", data.isLoggedIn);
    inquriyData.append("Otp", data.OTP);

    try {
      const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error submitting consultation request:", error);
      return {
        status: 500,
        data: {
          success: false,
          message: error.response?.data?.message,
        },
      };
    }
  };

  return (
    <div className="twowheelerinsurance-container">
      <Helmet>
        <title>Two Wheeler Insurance Advice | Stay Protected On Road</title>
        <meta
          name="description"
          content="Get personalized advice for two wheeler insurance. Compare plans and understand coverage to stay safe and secure on every ride."
        />
        <meta
          name="keywords"
          content="two wheeler insurance advice, stay protected on road, bike insurance India, motorcycle insurance advice, compare two wheeler plans"
        />
        <link rel="canonical" href="https://policysamjho.com/two-wheeler-insurance-advice/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Two Wheeler Insurance Advice",
            "description": "Personalized advice for choosing two wheeler insurance. Compare plans, understand coverages, and secure your rides with Policy Samjho guidance.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "serviceType": "Two Wheeler Insurance Consultation",
            "areaServed": "IN",
            "url": "https://policysamjho.com/two-wheeler-insurance-advice/",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9584484800",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <div className="twowheelerinsurance-hero-container">
        <div className="twowheelerinsurance-hero-text-box">
          <h1>
            <span style={{ color: "#192437" }}>Two Wheeler </span>
            <span style={{ color: "#F5A526" }}>Insurance Advice</span>
          </h1>
          <p
            style={{
              color: "black",
              fontWeight: "600",
              fontSize: "18px",
              textAlign: "justify",
            }}
          >
            Ensure your bike's safety with a comprehensive two-wheeler insurance policy that covers damages, theft,
            and third-party liabilities.
          </p>
        </div>

        <div className="twowheelerinsurance-hero-image-box twowheelerinsurance-imgslider">
          {imageSources.map((image, index) => (
            <img
              key={index}
              ref={(el) => (imageRefs.current[index] = el)}
              src={image}
              className="twowheelerinsurance-sliderimg"
              alt={`twowheeler-slide-${index}`}
              style={{ display: index === 0 ? "block" : "none" }}
            />
          ))}
        </div>
      </div>

      <div className="twowheelerinsurance-containform-container">
        <div className="col-md-6 twowheelerinsurance-info">
          <h2 className="twowheelerinsurance-heading">
            <span style={{ color: "#192437" }}>What is </span>
            <span style={{ color: "#F5A526" }}>Two-Wheeler Insurance?</span>
          </h2>
          <p className="twowheelerinsurance-text">
            Two-wheeler insurance provides financial protection by covering damages, accidents, theft,
            and third-party liabilities. It ensures you can ride stress-free without financial burdens.
          </p>

          <h2 className="twowheelerinsurance-subheading">
            <span style={{ color: "#192437" }}>Why is Two-Wheeler </span>
            <span style={{ color: "#F5A526" }}>Insurance Important?</span>
          </h2>
          <ul className="twowheelerinsurance-benefits">
            <li className="insurancepoints">Covers accidental damage</li>
            <li className="insurancepoints">Third-party liability coverage</li>
            <li className="insurancepoints">Protection from theft and loss</li>
            <li className="insurancepoints">Cashless repairs at network garages</li>
          </ul>

          <h2 className="twowheelerinsurance-subheading">
            <span style={{ color: "#192437" }}>Comprehensive Coverage & </span>
            <span style={{ color: "#F5A526" }}>Insurance Benefits</span>
          </h2>
          <p className="twowheelerinsurance-text spaced-text">
            Two-wheeler insurance ensures financial security by covering a wide range of risks,
            including accidental damage, theft, third-party liabilities, and natural calamities.
            It provides peace of mind while riding and reduces the financial impact of unforeseen events.
          </p>
        </div>

        <div>
          <h4 className="consultationform-heading">
            <span style={{ color: "#192437" }}>Get a Free </span>
            <span style={{ color: "#F5A526" }}> Two-Wheeler Insurance Quote</span>
          </h4>
          <ConsultationForm onSubmit={handleSubmit} />
        </div>
      </div>

      <PoliciesSlider category="Two Wheeler Insurance" />
      <ChatbotAi />
    </div>
  );
};

export default TwoWheelerInsurance;